import { LiveSiteResponse } from '../../../types';
import { doRequest } from '../../../utils/http';

/**
 * Gets the live site data as JSON.
 */
export const getLiveSite = async (): Promise<LiveSiteResponse> => {
  return doRequest(`https://livesite.jetstream.vpsvc.com/`).then((res) => res);
};
